import { render } from "./SubtitlesIOS.vue?vue&type=template&id=c631c2ac&scoped=true"
import script from "./SubtitlesIOS.vue?vue&type=script&lang=js"
export * from "./SubtitlesIOS.vue?vue&type=script&lang=js"

import "./SubtitlesIOS.vue?vue&type=style&index=0&id=c631c2ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c631c2ac"]])

export default __exports__